module.exports = __webpack_public_path__ + "media/icons/code-6a3213a8.svg";